/* eslint-disable max-len */
export default [
  {
    title: 'PLASTIC BAG RECYCLING',
    content: 'What Can Be Recycled?',
    commonProducts: [
      'Plastic grocery bags, plastic wrap, and film plastic'
    ],
    imageUrl: 'https://dam.thdstatic.com/content/production/WFVh3kvYTG_Ew2UlbcfzKQ/hzdOpnxF71-kyAYYW0x2uQ/Original%20file/Plastic_Bag_Recycling_Icons_with_Brand_Background.jpg'
  },
  {
    title: 'COMPACT FLUORESCENT\nBULB RECYCLING',
    content: 'What Can Be Recycled?',
    commonProducts: [
      'Unbroken indoor/outdoor compact fluorescent bulbs'
    ],
    imageUrl: 'https://dam.thdstatic.com/content/production/8XcrTOwMIEXRqnylEYxX6Q/BzSiAgzOUFSqlzgPnFnM0Q/Original%20file/Bulb_Recycling_Icons_with_Brand_Background.jpg'
  },
  {
    title: 'RECHARGEABLE\nBATTERY RECYCLING',
    content: 'What Can Be Recycled?',
    commonProducts: [
      'Undamaged rechargeable batteries used in power tools, cell phones, and laptops',
      'Nickel Cadmium (Ni-Cd), Lithium Ion (Li-ion), Small Sealed Lead Acid (SSLA/Pb), Nickel Metal Hydride (Ni-MH), Nickel Zinc (Ni-Zn)'
    ],
    imageUrl: 'https://dam.thdstatic.com/content/production/xnWNkN7nsnyYpJQ-ALtI8Q/omjEQdbjOKL0Ta3nYqylzg/Original%20file/Battery_Recycling_Icons_with_Brand_Background.jpg'
  }
];